@if (visibleOptionsExist | select) {
  <mx-expandable-card [expansionState]="expansionState" [lazyLoadContent]="false" class="mx-elevation-0"
                      expansionPanelClasses="border-[0.0625rem] border-[--mx-card-border-color]"
                      (expansionStateChanged)="onExpansionStateChanged($event)">
    <div header class="w-full">
      <div class="flex flex-row justify-between items-center w-full py-3">
        <span class="text-title-medium lg:text-headline-small">{{ cardTitle }}</span>

        <mx-expandable-card-toggle-button [state]="expansionState" [collapsedRotation]="-90" [expandedRotation]="0"/>
      </div>
    </div>

    <px-catalog-filter-options [options]="visibleOptions | select:[]" (selectionChanged)="onSelectionChanged($event)"/>

    @if (moreOptionsExist | select) {
      <mx-action-buttons>
        <mx-text-button startIcon="add" label="See All" (click)="onClickSeeAllButton()"/>
      </mx-action-buttons>
    }
  </mx-expandable-card>
}
